{
  "PHONE_CTRLS": {
    "EXTENSION_BANNER": {
      "TEXT": "Chrome plėtinys neįdiegtas.",
      "CTA": "Įdiegti plėtinį"
    },
    "TABS": {
      "PHONE": "Telefonas",
      "SMS": "SMS",
      "HISTORY": "Istorija"
    },
    "HISTORY": {
      "OPEN": "Atidaryti",
      "RECENT": "Naujausi",
      "MISSED": "Praleisti",
      "LOADING": "Kraunami skambučiai...",
      "EMPTY": "Čia skambučių nėra",
      "ERROR": "Nepavyko įkelti skambučių",
      "CALL": "Perskambinti",
      "CALL_STATUS": {
        "BUTTON": "Nustatyti skambučio būseną",
        "TITLE": "Skambučio būsena",
        "SEARCH_PLACEHOLDER": "Ieškoti būsenų...",
        "LOADING": "Kraunamos būsenos...",
        "NO_OPTIONS": "Nesukonfigūruota jokių skambučio būsenų",
        "NO_MATCH": "Nė viena būsena neatitinka",
        "OPTIONS_ERROR": "Nepavyko įkelti būsenų",
        "RETRY": "Bandyti dar kartą",
        "CONFIRM_QUESTION": "Ar tikrai norite nustatyti būseną „{status}“ ir išspręsti pokalbį?",
        "CONFIRM": "Patvirtinti",
        "BACK": "Atgal",
        "CANCEL": "Atšaukti",
        "SAVING": "Išsaugoma...",
        "SAVE_ERROR": "Nepavyko išsaugoti būsenos",
        "RESOLVE_ERROR": "Būsena išsaugota, bet nepavyko išspręsti pokalbio"
      }
    },
    "SMS": {
      "NUMBER_PLACEHOLDER": "Telefono numeris, pvz. +421903000000",
      "BODY_PLACEHOLDER": "Parašykite žinutę...",
      "SEGMENTS": "({segments} SMS)",
      "SEND": "Siųsti SMS",
      "SENDING": "Siunčiama...",
      "SENT": "SMS išsiųsta",
      "LOADING": "Įkeliamos SMS gautųjų dėžutės...",
      "NO_INBOX": "Ši paskyra neturi SMS gautųjų dėžutės, todėl SMS išsiųsti negalima.",
      "INVALID_NUMBER": "Įveskite numerį tarptautiniu formatu, įskaitant + pradžioje.",
      "ERROR": "SMS išsiųsti nepavyko. Bandykite dar kartą."
    },
    "ACTIONS": {
      "CONNECT": "Prisijungti",
      "GO_TO_TAB": "Eiti į tą skirtuką",
      "DISCONNECT": "Atsijungti",
      "ANSWER": "Atsiliepti",
      "HANGUP": "Baigti skambutį",
      "HOLD": "Sulaikyti",
      "MUTE": "Nutildyti mikrofoną",
      "SILENCE": "Nutildyti garsą",
      "TRANSFER": "Persiųsti",
      "COMPLETE_TRANSFER": "Baigti persiuntimą",
      "RETURN_TO_CALLER": "Grįžti prie skambinančiojo",
      "CANCEL_TRANSFER": "Atšaukti persiuntimą",
      "DIALPAD": "Rodyti klaviatūrą",
      "OPEN_CONVERSATION": "Atidaryti pokalbį"
    },
    "NOTIFICATIONS": {
      "INCOMING_CALL": "Gaunamas skambutis",
      "INCOMING_CALL_FROM": "Gaunamas skambutis iš {name} ({number})",
      "INCOMING_CALL_FROM_NUMBER": "Gaunamas skambutis iš {number}",
      "ANSWER": "Atsiliepti",
      "DECLINE": "Atmesti"
    },
    "TRANSFER": {
      "TITLE": "Skambučio persiuntimas",
      "PLACEHOLDER": "Įveskite persiuntimo numerį...",
      "SEARCH_PLACEHOLDER": "Ieškoti agentų...",
      "TARGET_PLACEHOLDER": "Pasirinktas persiuntimo tikslas",
      "CONFIRM": "Persiųsti",
      "MODE_DIRECT": "Persiųsti dabar",
      "MODE_CONSULT": "Pirmiausia skambinti agentui",
      "CANCEL": "Atšaukti"
    },
    "QUEUE_BREAK": {
      "CONFIRM_BREAK": "Ar tikrai norite pereiti į pertrauką visose eilėse?",
      "CONFIRM_READY": "Ar tikrai norite grįžti į pasirengimo būseną visose eilėse?",
      "CONFIRM_BREAK_QUEUE": "Ar tikrai norite atsijungti nuo eilės {queue}?",
      "CONFIRM_READY_QUEUE": "Ar tikrai norite prisijungti prie eilės {queue}?",
      "LOGIN_TO_QUEUE": "Prisijungti",
      "LOGOUT_FROM_QUEUE": "Atsijungti",
      "LOGIN_TO_ALL_QUEUES": "Prisijungti prie visų eilių",
      "LOGOUT_FROM_ALL_QUEUES": "Atsijungti nuo visų eilių",
      "OPTION_LOGOUT": "Atsijungti",
      "OPTION_BREAK": "Pertrauka",
      "OPTION_LUNCH": "Pietūs",
      "OPTION_AWAY": "Pasitraukęs",
      "OPTION_DO_NOT_DISTURB": "Netrukdyti",
      "OPTION_BUSINESS_TRIP": "Komandiruotė",
      "CONFIRM": "Patvirtinti",
      "CANCEL": "Atšaukti"
    },
    "CONNECTION_ERROR": {
      "TITLE": "Nėra ryšio su telefono sistema",
      "MESSAGE": "Panašu, kad nutrūko interneto ryšys. Patikrinkite jį ir bandykite dar kartą.",
      "CREDENTIALS_TITLE": "Telefono sistema atmetė jūsų prisijungimo duomenis",
      "CREDENTIALS_MESSAGE": "Telefono sistema atmetė profilyje išsaugotą naudotojo vardą arba slaptažodį. Patikrinkite juos skiltyje Profilio Nustatymai arba kreipkitės į administratorių.",
      "CONFIGURATION_TITLE": "Telefono nustatymai neteisingi",
      "CONFIGURATION_MESSAGE": "SIP naudotojo vardas arba serverio adresas neatitinka tinkamo formato, todėl telefonas negali prisijungti. Ištaisykite tai skiltyje Profilio Nustatymai.",
      "NETWORK_SHORT": "Nepavyko prisijungti",
      "CREDENTIALS_SHORT": "Duomenys atmesti",
      "CONFIGURATION_SHORT": "Netinkami nustatymai",
      "RETRY": "Bandyti dar kartą",
      "DISMISS": "Atšaukti"
    },
    "CONNECTION_QUALITY": "Ryšio kokybė",
    "CONNECTION_QUALITY_EXCELLENT": "Puiki",
    "CONNECTION_QUALITY_GOOD": "Gera",
    "CONNECTION_QUALITY_FAIR": "Vidutinė",
    "CONNECTION_QUALITY_POOR": "Prasta",
    "CONNECTION_QUALITY_DISCONNECTED": "Atjungta",
    "STATUS": {
      "OFFLINE": "Telefonas neprisijungęs",
      "IN_OTHER_TAB": "Telefonas prijungtas kitame skirtuke",
      "CONNECTING": "Jungiamasi...",
      "DISCONNECTING": "Atsijungiama...",
      "ONLINE": "Telefonas prisijungęs",
      "DIALING": "Skambinama",
      "TRANSFERRING": "Persiunčiama...",
      "CONSULTING": "Kalbama su agentu",
      "CALLER_ON_HOLD": "Skambinantysis laukia",
      "BUSY": "Užimta",
      "DND": "DND",
      "UNAVAILABLE": "Nepasiekiamas",
      "REJECTED": "Skambutis atmestas",
      "CALL_FAILED": "Skambutis nepavyko"
    },
    "QUEUES": {
      "MORE": "Daugiau eilių"
    }
  },
  "DIAL_REDIRECT": {
    "DIALING": "Skambinama {number}… Šį skirtuką galite uždaryti.",
    "NO_NUMBER": "Nenurodytas numeris. Naudokite ?number=+420..."
  },
  "PHONE_DIAL": {
    "PLACEHOLDER": "Įveskite telefono numerį...",
    "ACTIONS": {
      "DIAL": "Skambinti",
      "DIAL_FROM": "Pasirinkite numerį, iš kurio skambinate"
    },
    "DIAL_FROM": {
      "TITLE": "Skambinti iš gautųjų numerio"
    },
    "VALIDATION": {
      "REQUIRED": "Būtina nurodyti telefono numerį",
      "INVALID_FORMAT": "Neteisingas telefono numerio formatas"
    }
  },
  "PHONE_AUDIO": {
    "TITLE": "Garso nustatymai ir testavimas",
    "SELECT_DEVICE": "Pasirinkite įrenginį...",
    "SYSTEM_DEFAULT": "Sistemos numatytasis",
    "SAVED": "Išsaugota",
    "DISCONNECTED_SUFFIX": "neprijungtas",
    "DEVICE_DISCONNECTED": "Pasirinktas įrenginys neprijungtas. Skambučiams naudojamas sistemos numatytasis įrenginys, kol jis vėl prisijungs.",
    "MICROPHONE": {
      "TITLE": "Mikrofonas",
      "START_TEST": "Testuoti mikrofoną",
      "STOP_TEST": "Stabdyti testą",
      "LEVEL": "Lygis:",
      "VERDICT": {
        "LISTENING": "Pasakykite ką nors į mikrofoną…",
        "SILENT": "Jūsų negirdi. Patikrinkite, ar mikrofonas įjungtas ir pasirinktas tinkamas.",
        "LOW": "Jus girdi tik tyliai. Pasirinkite kitą mikrofoną arba sureguliuokite įvesties garsumą sistemos nustatymuose.",
        "GOOD": "Geras garsas — jus gerai girdi."
      }
    },
    "SPEAKER": {
      "TITLE": "Garsiakalbis",
      "TEST": "Testuoti garsiakalbį",
      "TESTING": "Testuojama...",
      "VOLUME": "Garsumas:",
      "USING_DEFAULT": "Pasirinkta išvestis nepasiekiama — grojama per sistemos numatytąjį įrenginį."
    },
    "DONE": "Atlikta",
    "ERRORS": {
      "MICROPHONE_ACCESS": "Klaida pasiekiant mikrofoną. Patikrinkite leidimus.",
      "MICROPHONE_PERMISSION_DENIED": "Prieiga prie mikrofono užblokuota. Leiskite ją naršyklės svetainės nustatymuose, kad galėtumėte naudotis telefonu.",
      "MICROPHONE_SILENT": "Jūsų mikrofonas neaptinka jokio garso. Patikrinkite garso nustatymus.",
      "EXTENSION_REQUIRED": "Telefono plėtinys neaptiktas. Įdiekite arba įjunkite jį, kad galėtumėte naudoti mikrofoną.",
      "SPEAKER_TEST": "Klaida testuojant garsiakalbio išvestį."
    }
  },
  "PHONE_STATUS": {
    "OFFLINE": "Neprisijungęs",
    "ONLINE": "Prisijungęs",
    "BUSY": "Užimta"
  },
  "QUEUE_STATUS": {
    "READY": "Pasirengęs",
    "NOT_READY": "Nepriima skambučių",
    "WRAP_UP": "Užbaigimas",
    "BREAK": "Pertrauka",
    "LUNCH": "Pietūs",
    "AWAY": "Pasitraukęs",
    "DO_NOT_DISTURB": "Netrukdyti",
    "BUSINESS_TRIP": "Komandiruotė",
    "OTHER_CALL": "Kitas skambutis",
    "QUEUE_CALL": "Eilės skambutis",
    "OFFLINE": "Neprisijungęs",
    "ONLINE": "Prisijungęs",
    "NO_ACCESS": "Nėra telefono",
    "PARTIALLY_READY": "Iš dalies pasirengęs",
    "MIXED": "Mišrus",
    "CHAT_ONLINE": "Prisijungęs (pokalbiai)",
    "CHAT_BUSY": "Užimta (pokalbiai)",
    "CHAT_OFFLINE": "Neprisijungęs (pokalbiai)"
  }
}
